import { Avatar } from 'antd';
import './MDLPerson.scss';
import { Person } from '../person';

function MDLPerson(props: Person) {

  return (
    <div className='mdl-person'>
      <div className='mdl-person-left'>
        <Avatar className='mdl-person-avatar' size={128} src={props.imgPath}></Avatar>
      </div>
      <div className='mdl-person-right'>
        <div className='centerer'>
          <div className='mdl-person-name'>{props.firstName + ' ' + props.lastName + (props.title ? `, ${props.title}` : '')}</div>
          <div className='mdl-person-role'>{(props.role ? props.role + '  |  ':'') + props.email }</div>
        </div>

      </div>
    </div>
  )
}

export default MDLPerson;